import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../core/authentication.service';
import { EncryDecryService } from '../core/encry-decry.service';
import { ToastrService } from 'ngx-toastr';
import { Panel } from '../enums';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  isLoadingResults = false;
  submitted = false;
  returnUrl: string;
  test: Date;
  rememberMe: boolean = false;
  panelOptions: Panel;
  public currentUser;


  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private encryDecryService: EncryDecryService,
    private toastr: ToastrService,
    public auth: AuthenticationService,) { }


  ngOnInit(): void {
    this.isalreadyLoggedIn();
    this.test = new Date();
    this.loginForm = this.formBuilder.group({
      'email': [null, Validators.required],
      'password': [null, Validators.required],
    });

    //this.authenticationService.logout();

    // get return url from route parameters or default to ''
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
    if (localStorage.getItem("rememberMeCustomer")) {
      var data = JSON.parse(this.encryDecryService.Decrypt(localStorage.getItem('rememberMeCustomer')));
      this.loginForm.setValue({ email: data.email, password: data.password });
      this.rememberMe = true;
    }
  }
  // to access the form fields
  get fval() { return this.loginForm.controls; }

  onFormSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.setRememberMe();
    this.isLoadingResults = true;
    this.authenticationService.login(this.fval.email.value.trim(), this.encryDecryService.Encrypt(this.fval.password.value))
      .subscribe(
        data => {

          this.currentUser = localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : '';

          if (this.currentUser.panel == Panel.Admin)
            //this.router.navigate(['/portalLanding']);
            this.router.navigate(['/portalLanding'], { queryParams: { returnUrl: this.returnUrl } });
          else
            this.router.navigate(['/dashboard']);
          //this.router.navigate(['/']);
          if (!this.returnUrl) {
            if (this.auth.hasPrivilege(Panel[Panel.Admin])) {
              this.returnUrl = '/portalLanding';
            }
            else {
              if (data?.result?.user?.franchise) {
                if (data?.result?.user?.franchise?.country?.countryCode == "AZ") {
                  localStorage.setItem('isAZ', "AZ");
                } else {
                  localStorage.getItem('isAZ') ? localStorage.removeItem('isAZ') : '';
                }
                localStorage.setItem('countryId', data?.result?.user?.franchise?.country?.countryId);
                // localStorage.setItem('headerImage', data?.result?.user?.franchise?.country?.flagUrl);            
                localStorage.setItem('title', data?.result?.user?.franchise?.franchiseName);
                localStorage.removeItem('isWarehouse');
                localStorage.removeItem('isAdmin');
              }
              this.returnUrl = '/dashboard';
            }
            this.router.navigate([this.returnUrl]);
          }
          //this.router.navigate([this.returnUrl]);
        },
        err => {
          this.toastr.error(err, 'Error');
          console.log(err);
          this.isLoadingResults = false;
        });
  }

  setRememberMe() {
    if (this.rememberMe) {
      var data = { 'email': this.fval.email.value, 'password': this.fval.password.value };
      localStorage.setItem('rememberMeCustomer', this.encryDecryService.Encrypt(JSON.stringify(data)));
    } else {
      localStorage.removeItem('rememberMeCustomer');
    }
  }

  isalreadyLoggedIn() {    
    let currentUser = localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : '';
    let returnUrl1 = "";
    let Expiration = localStorage.getItem('expiration') ? JSON.parse(localStorage.getItem('expiration')) : '';
    if (Expiration && Expiration != null && currentUser && Expiration != "" && currentUser != "" && new Date(Expiration).getDate() < new Date().getDate()) {
      // authorised so return to panel      
      this.auth.logout();
      returnUrl1 = '/login';
      // this.returnUrl = '/dashboard';        
      this.router.navigate([returnUrl1]);

    } else {

      if (currentUser != null && currentUser != "") {
        if (currentUser.panel == Panel.Admin)
          //this.router.navigate(['/portalLanding']);
          this.router.navigate(['/portalLanding'], { queryParams: { returnUrl: returnUrl1 } });
        else
          this.router.navigate(['/dashboard']);
        //this.router.navigate(['/']);
        if (!returnUrl1) {
          if (this.auth.hasPrivilege(Panel[Panel.Admin])) {
            returnUrl1 = '/portalLanding';
          }
          else {
            if (currentUser.franchise != null) {
              if (currentUser.franchise?.country?.countryCode == "AZ") {
                localStorage.setItem('isAZ', "AZ");
              } else {
                localStorage.getItem('isAZ') ? localStorage.removeItem('isAZ') : '';
              }
              localStorage.setItem('countryId', currentUser.franchise?.country?.countryId);
              // localStorage.setItem('headerImage', data?.result?.user?.franchise?.country?.flagUrl);            
              localStorage.setItem('title', currentUser.franchise?.franchiseName);
              localStorage.removeItem('isWarehouse');
              localStorage.removeItem('isAdmin');
            }
            returnUrl1 = '/dashboard';
          }
          this.router.navigate([returnUrl1]);
        }
      }
    }
  }
}
